import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signIn, signUp } from './authService';
import { Form, Input, Button, message } from 'antd';

const LoginPage = () => {
  const [isSignUp, setIsSignUp] = useState(false);
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const handleSignIn = async (values: { email: string; password: string; }) => {
    try {
      const session = await signIn(values.email, values.password);
      console.log('Sign in successful', session);
      if (session && typeof session.AccessToken !== 'undefined') {
        sessionStorage.setItem('accessToken', session.AccessToken);
        console.log('Sign in successful', session);
        navigate('/studylist');
      } else {
        console.error('SignIn session or AccessToken is undefined.');
        messageApi.error('Sign in failed: session or AccessToken is undefined.');
      }
    } catch (error:any) {
      console.error('Sign in failed', error);
      messageApi.error(`Sign in failed: ${error.message}`);
    }
  };

  const handleSignUp = async (values: { email: string; password: string; confirmPassword: string; }) => {
    if (values.password !== values.confirmPassword) {
      console.log(`Passwords do not match`);
      messageApi.error('Passwords do not match');
      return;
    }
    try {
      await signUp(values.email, values.password);
      navigate('/confirm', { state: { email: values.email } });
    } catch (error: any ) {
      console.log(`Sign up failed: ${error.message}`)
      messageApi.error(`Sign up failed: ${error.message}`);

    }
  };

  return (
    <div className="loginForm">
      {contextHolder}
      <h1>Welcome</h1>
      <h4>{isSignUp ? 'Sign up to create an account' : 'Sign in to your account'}</h4>
      <Form
        onFinish={isSignUp ? handleSignUp : handleSignIn}
        style={{ maxWidth: 300 }}
      >
        <Form.Item
          name="email"
          rules={[{ required: true, message: 'Please input your Email!', type: 'email' }]}
        >
          <Input placeholder="Email" />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Please input your Password!' }]}
        >
          <Input.Password placeholder="Password" />
        </Form.Item>
        {isSignUp && (
          <Form.Item
            name="confirmPassword"
            dependencies={['password']}
            rules={[
              { required: true, message: 'Please confirm your Password!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('The two passwords that you entered do not match!'));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirm Password" />
          </Form.Item>
        )}
        <Form.Item>
          <Button type="primary" htmlType="submit">
            {isSignUp ? 'Sign Up' : 'Sign In'}
          </Button>
        </Form.Item>
      </Form>
      <Button onClick={() => setIsSignUp(!isSignUp)} style={{ marginTop: 16 }}>
        {isSignUp ? 'Already have an account? Sign In' : 'Need an account? Sign Up'}
      </Button>
    </div>
  );
};

export default LoginPage;

